import state from '~store/modules/services/state'
import actions from '~store/modules/services/actions'

export default {
  state,
  actions
}
